import { render, staticRenderFns } from "./EditReference.vue?vue&type=template&id=cc0b992e&scoped=true&"
import script from "./EditReference.vue?vue&type=script&lang=js&"
export * from "./EditReference.vue?vue&type=script&lang=js&"
import style0 from "./EditReference.vue?vue&type=style&index=0&id=cc0b992e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0b992e",
  null
  
)

export default component.exports